import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-confirm-modal",
  templateUrl: "./confirm-modal.component.html",
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) { 

    data.style = data.style ?? "";
    data.confirmText = data.confirmText ?? "Confirmar";
    data.cancelText = data.cancelText ?? "Fechar";

  }

  ngOnInit() {}
}
export interface ConfirmDialogData {
  title: string;
  msg: string;
  style: string;
  confirmText: string;
  cancelText: string;
}
